import { Link } from "react-router-dom";
import { Leaf, Info } from "lucide-react";

const LINES = [
  { label: "Cuidado Personal No Tóxico", path: "/categoria/cuidado-personal" },
  { label: "Hogar Limpio & Zero Waste", path: "/categoria/hogar-limpio" },
  { label: "Nutrición Limpia", path: "/categoria/nutricion-limpia" },
  { label: "Longevidad & Salud Celular", path: "/categoria/longevidad-celular" },
];

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-secondary/30 mt-20">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-emerald-500 to-cyan-500 text-slate-950">
                <Leaf className="h-4 w-4" strokeWidth={2.4} />
              </span>
              <span className="font-display font-extrabold">ZeroToxic<span className="text-emerald-400">Market</span></span>
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Curaduría independiente de productos no tóxicos para la longevidad y la vida limpia.
            </p>
          </div>

          <div>
            <h4 className="font-mono-tech text-xs uppercase tracking-widest text-emerald-400 mb-4">Líneas</h4>
            <ul className="space-y-2">
              {LINES.map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-mono-tech text-xs uppercase tracking-widest text-emerald-400 mb-4">Explorar</h4>
            <ul className="space-y-2">
              <li><Link to="/catalogo" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Catálogo Completo</Link></li>
              <li><Link to="/blog" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Guías & Educación</Link></li>
              <li><Link to="/favoritos" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Mis Favoritos</Link></li>
              <li><a href="/docs/metodologia-sello-zerotoxic.md" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Metodología Sello ZeroToxic</a></li>
              <li><a href="/docs/guia-30-dias-detox.md" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Guía Detox 30 Días</a></li>
              <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Panel de Administración</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono-tech text-xs uppercase tracking-widest text-emerald-400 mb-4">Arquitectura</h4>
            <ul className="space-y-2">
              <li><a href="/docs/sitemap-menu-footer.md" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Menú & Footer (Sitemap)</a></li>
              <li><a href="/docs/arbol-categorias.md" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Árbol de Categorías</a></li>
              <li><a href="/docs/tags-salud.md" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Etiquetas de Salud</a></li>
              <li><a href="/docs/taxonomia.json" target="_blank" rel="noopener noreferrer" className="text-sm text-muted-foreground hover:text-emerald-400 transition-colors">Taxonomía JSON</a></li>
            </ul>
          </div>
        </div>

        <div data-testid="ftc-footer-disclosure" className="mt-12 flex gap-3 rounded-xl border border-amber-500/20 bg-amber-500/5 p-4">
          <Info className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
          <p className="text-xs text-muted-foreground leading-relaxed">
            <span className="font-semibold text-amber-500">Declaración de Afiliado (FTC): </span>
            ZeroToxicMarket es un catálogo de curaduría independiente. Algunos enlaces son de afiliados; si compras a través de ellos,
            podemos recibir una pequeña comisión sin costo adicional para ti. Esto nos ayuda a seguir investigando productos limpios.
          </p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-muted-foreground">
          <span>© {new Date().getFullYear()} ZeroToxicMarket. Todos los derechos reservados.</span>
          <div className="flex gap-4">
            <span className="hover:text-emerald-400 cursor-pointer transition-colors">Aviso de Privacidad</span>
            <span className="hover:text-emerald-400 cursor-pointer transition-colors">Términos de Servicio</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
